import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { Markdown } from "@/components/Markdown";

export const METRICS = [["touches", "Touches"], ["completed_passes", "Completed passes"], ["carries", "Carries"], ["shots", "Shots"]];

const Table = ({ rows, testId }) => (
  <table data-testid={testId} className="w-full text-sm">
    <thead><tr className="text-left font-data text-[10px] uppercase tracking-wider text-slate-500">
      <th className="py-2 pr-3">Player</th>{METRICS.map(([k, l]) => <th key={k} className="py-2 pr-3 text-right">{l}</th>)}
    </tr></thead>
    <tbody>
      {rows.map((r) => (
        <tr key={r.entry} className="border-t border-slate-800">
          <td className="py-2 pr-3 text-white">{r.name || r.entry}<span className="block text-[11px] text-slate-500">{r.entry}</span></td>
          {METRICS.map(([k]) => <td key={k} className="py-2 pr-3 text-right font-data">{r.metrics?.[k] ?? "—"}</td>)}
        </tr>
      ))}
    </tbody>
  </table>
);

export const MatchResultDialog = ({ id, onClose }) => {
  const [m, setM] = useState(null);
  useEffect(() => { setM(null); if (id) api.get(`/admin/match-analyses/${id}`).then((r) => setM(r.data)); }, [id]);
  return (
    <Dialog open={!!id} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="match-result-dialog" className="max-h-[85vh] max-w-4xl overflow-y-auto border-slate-800 bg-[#131927]">
        <DialogHeader><DialogTitle className="font-display text-2xl uppercase">{m ? (m.label || `${m.teams["Team 1"].team_name} vs ${m.teams["Team 2"].team_name}`) : "Loading"}</DialogTitle></DialogHeader>
        {m && (
          <div className="space-y-6">
            {m.tracked_only && (
              <p data-testid="match-tracked-only-note" className="rounded-lg border border-amber-500/40 bg-amber-500/10 p-3 text-sm text-amber-200">
                The analyzer didn't use the rosters, so players are identified by tracking number only. Nothing was saved to profiles.
              </p>
            )}
            {["Team 1", "Team 2"].map((k) => (
              <div key={k}>
                <h4 className="eyebrow mb-2">{k} · {m.teams[k].team_name}</h4>
                {m.results?.[k]?.length ? <Table rows={m.results[k]} testId={`match-result-table-${k.replace(" ", "")}`} /> : <p className="text-sm text-slate-500">No players matched.</p>}
              </div>
            ))}
            {m.unmatched?.length > 0 && (
              <div data-testid="match-unmatched">
                <h4 className="eyebrow mb-2 !text-amber-300">{m.tracked_only ? "Tracked players" : "Unmatched"} ({m.unmatched.length}), not saved to any profile</h4>
                <Table rows={m.unmatched.map((u) => ({ ...u, name: `${u.team}: ${u.entry}` }))} testId="match-unmatched-table" />
              </div>
            )}
            <div>
              <h4 className="eyebrow mb-2">Scouting report</h4>
              {m.report ? <Markdown testId="match-report">{m.report}</Markdown> : <p data-testid="match-report" className="text-sm text-slate-500">The analyzer returned no report.</p>}
            </div>
            <details className="text-xs text-slate-500"><summary className="cursor-pointer">Raw analyzer response</summary>
              <pre className="mt-2 max-h-64 overflow-auto rounded bg-[#0B0F19] p-3">{JSON.stringify(m.raw, null, 1)}</pre></details>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
